module.exports = __webpack_public_path__ + "img/Weapon_301.1d95e71a.png";